(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    /**
     * A service for creating a modal item chooser. Invoke by calling {@link ihh-common-web.IhhModalItemChooser.open open}.
     * @ngdoc service
     * @name IhhModalItemChooser
     * @memberOf ihh-common-web
     */
    angular
        .module('ihh-common-web')
        .service('IhhModalItemChooser', IhhModalItemChooser);

    IhhModalItemChooser.$inject = ['$modal', '$rootScope'];

    function IhhModalItemChooser($modal, $rootScope) {

        /**
         * Opens a modal item chooser dialog.
         * @ngdoc method
         * @name open
         * @memberOf ihh-common-web.IhhModalItemChooser
         * @param {ihh-common-web.ihh-item-chooser.config} config a configuration object see the {@link ihh-common-web.ihh-item-chooser} directive for details
         * @param {Boolean} retainItems if truthy, then does not clear the content of the item chooser when the dialog closes
         */
        this.open = function(config, retainItems) {

            // Save off and replace the passed select function so that clicking an item in the list closes the dialog.
            var originalSelectedFn = config.selectedFn;
            config.setSelectedFn(function(item) {
                modalInstance.close(item);
            });

            // Some configs get used in a non-modal context where they are transcluded, but the model template below does not transclude
            var originalTransclude = config.transclude;
            config.setTransclude(false);

            var modalScope = $rootScope.$new();

            modalScope.config = config;

            // using scope instead of resolve to help avoid delay in displaying modal
            var modalInstance = $modal.open({
                templateUrl: 'item-chooser/modal-item-chooser.tpl.html',
                controller: 'IhhModalItemChooserCtrl',
                scope: modalScope
            });

            // Restore the original select function no matter how the dialog goes down
            modalInstance.result.then(function(item) {
                config.selectedFn = originalSelectedFn;
                config.setTransclude(originalTransclude);

                if (config.selectedFn) {
                    config.selectedFn(item);
                }
            }, function() {
                if (angular.isDefined(config.canceledFn) && angular.isFunction(config.canceledFn)) {
                    config.canceledFn();
                }
                config.selectedFn = originalSelectedFn;
                config.setTransclude(originalTransclude);
            }).finally(function() {
                if (!retainItems) {
                    config.clear();
                }
            });
        };
    }
})();